import { useState } from 'react'
import { RefreshCw, X } from 'lucide-react'
import { useUI } from '../store/ui'
import { aplicarActualizacionApp } from '../lib/actualizacionApp'

/** Aviso de que hay una versión nueva, con un botón para aplicarla
 *  cuando la persona quiera —nunca se recarga sola. Ver main.tsx y
 *  sw.ts para el porqué: antes la recarga automática hacía aparecer de
 *  nuevo la pantalla de carga a los pocos minutos de estar usando la
 *  app, sin aviso. */
export function AvisoActualizacion() {
  const actualizacionLista = useUI((s) => s.actualizacionLista)
  const setActualizacionLista = useUI((s) => s.setActualizacionLista)
  const [aplicando, setAplicando] = useState(false)

  if (!actualizacionLista) return null

  return (
    <div className="safe-top fixed inset-x-3 top-3 z-50">
      <div className="mx-auto flex max-w-lg items-center gap-2.5 rounded-2xl border-2 border-bosque-400 superficie-barra px-3.5 py-3 sombra-flotante">
        <RefreshCw className={cnGiro(aplicando)} />
        <p className="min-w-0 flex-1 text-[13px] font-semibold texto-base">
          Hay una versión nueva de NovaBerry
        </p>
        {!aplicando && (
          <button
            onClick={() => setActualizacionLista(false)}
            className="grid size-7 shrink-0 place-items-center rounded-lg texto-tenue transition-colors hover:superficie-hundida"
            aria-label="Ahora no"
          >
            <X className="size-4" />
          </button>
        )}
        <button
          onClick={() => {
            setAplicando(true)
            aplicarActualizacionApp()
          }}
          disabled={aplicando}
          className="shrink-0 rounded-xl bg-bosque-500 px-3 py-1.5 text-[13px] font-bold text-white transition-colors hover:bg-bosque-600 disabled:opacity-70"
        >
          {aplicando ? 'Actualizando…' : 'Actualizar'}
        </button>
      </div>
    </div>
  )
}

function cnGiro(girando: boolean) {
  return girando
    ? 'size-4 shrink-0 animate-spin text-bosque-500'
    : 'size-4 shrink-0 text-bosque-500'
}
